import { formatDateDDMMYYYY } from "./dateFormatter";
import { getDataFromDataKey } from "./getDataFromKey";

export const excelDataFormatter = (headers, data) => {
  console.log({ data, headers });
  const data_copy = structuredClone(data);

  const filteredData = data_copy.map((item, index) => {
    item.index = index + 1; // Add serial number to each item
    const newItem = {};
    headers.forEach((header) => {
      if (header.key) {
        newItem[header.label] = getDataFromDataKey(item, header.key);
      }

      if (header.fieldType === "select_value") {
        newItem[header.label] = getDataFromDataKey(item, header.key)
          ? getDataFromDataKey(item, header.key)
              ?.toString()
              ?.split("_")
              ?.join(" ")
              ?.toCapitalize()
          : "";
      }
      if (header.fieldType === "number") {
        newItem[header.label] = Number(getDataFromDataKey(item, header.key))
          ? Number(getDataFromDataKey(item, header.key))
          : Number(getDataFromDataKey(item, header.key)) === 0
            ? 0
            : "";
      }
      if (header.fieldType === "date") {
        newItem[header.label] = getDataFromDataKey(item, header.key)
          ? formatDateDDMMYYYY(
              new Date(getDataFromDataKey(item, header.key).split("T")[0]),
            )
          : "";
      }
      if (header.fieldType === "bool") {
        newItem[header.label] = Boolean(getDataFromDataKey(item, header.key))
          ? "Yes"
          : "No";
      }
      if (header?.render) {
        newItem[header.label] = header.render(item);
      }
    });
    return newItem;
  });

  console.log({ filteredData });

  return filteredData;
};
